// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields} = state;

	let poaTypeSelected = false;
	for (let i = 0; i < fields.type_of_poa.options.length; i++)
	{
		if (fields.type_of_poa.options[i].checked)
		{
			poaTypeSelected = true;
		}
	}

	if (!poaTypeSelected)
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Omfattning.fulfillment.js